import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import DupontButton from "../components/DupontButton";
import Header from "../components/Header";
import createNotification, {
  ERROR_NOTIFICATION,
  SUCCESS_NOTIFICATION,
} from "../components/Notifications";

import { acceptTC,accessRequest } from "../network/cipAPI";

import "./index.scss";

const RequestAccess = () => {
  const { t } = useTranslation();
  const companyName = useSelector((state) => state.companyName);

  const [displayMessage, setDisplayMessage] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);

  const handleConfirm = async () => {
    setDisplayMessage(true);
    try {
      const payload = {
        request_status: 1,
        company_name: companyName,
      };
      const response = await accessRequest(payload);
      await acceptTC();
      if (response) {
        createNotification(
          SUCCESS_NOTIFICATION,
          t("requestAcess.requestNotification"),
          "",
        );
      } else {
        createNotification(ERROR_NOTIFICATION, response.detail.error, "");
      }
    } catch (error) {
      console.error("Error during raising the request:", error);
    } finally {
      setDisplayMessage(true);
    }
  };

  return (
    <div>
      <Header />

      <div className="request-access-main">
        {displayMessage ? (
          <div className="message-text">{t("requestAcess.message")}</div>
        ) : (
          <div className="terms-section">
            {/* Terms and Conditions Section */}
            <div className="terms-content">
              <div className="terms-title">
                <p>
                  <b>{"DIGITAL PROGRAM TERMS AND CONDITIONS OF USE"}</b>
                </p>
              </div>
              <div className="subheading__title2 marginBtm20">
                {t("terms.firstPara")}
              </div>
              <div className="subheading__title2 terms-list">
                <div className="marginBtm10">
                  1. <u>{t("terms.defination")}</u>
                  {t("terms.definationText")}
                </div>
                <div className="terms-container margin-top-10">
                  <div className="marginBtm5">
                    <b>{t("terms.accessPeriod")}</b>
                    {t("terms.accessPeriodText")}
                  </div>
                  <div className="marginBtm5">
                    <b>{t("terms.affiliate")}</b>
                    {t("terms.affiliateText")}
                  </div>
                  <div className="marginBtm5">
                    <b>{t("terms.customerData")}</b>
                    {t("terms.customerDataText")}
                  </div>
                  <div className="marginBtm5">
                    <b>{t("terms.derivedData")}</b>
                    {t("terms.derivedDataText")}
                  </div>
                  <div className="marginBtm5">
                    <b>{t("terms.documentation")}</b>
                    {t("terms.documentationText")}
                  </div>
                  <div className="marginBtm5">
                    <b>{t("terms.software")}</b>
                    {t("terms.softwareText")}
                  </div>
                </div>
                <div className="marginBtm10">
                  2. <u>{t("terms.programLincense")}</u>
                  {t("terms.programLincenseText")}
                </div>
                <div className="marginBtm10">
                  3. <u>{t("terms.confidentiality")}</u>
                  {t("terms.confidentialityText")}
                </div>
                <div className="marginBtm10">
                  4. <u>{t("terms.customerrespo")}</u>
                  {t("terms.customerrespoText")}
                </div>
                <div className="marginBtm10">
                  5. <u>{t("terms.customerDataLincense")}</u>
                  {t("terms.customerDataLincenseText")}
                </div>
                <div className="marginBtm10">
                  6. <u>{t("terms.useOfCustomerData")}</u>
                  {t("terms.useOfCustomerDataText")}
                </div>
                <div className="marginBtm10">
                  7. <u>{t("terms.dupontPrivacyPolicy")}</u>
                  {t("terms.dupontPrivacyPolicyText")}
                </div>
                <div className="marginBtm10">
                  8. <u>{t("terms.dataSecurity")}</u>
                  {t("terms.dataSecurityText")}
                </div>
                <div className="marginBtm10">
                  9. <u>{t("terms.dupontWarrenties")}</u>
                  {t("terms.dupontWarrentiesText")}
                </div>
                <div className="marginBtm10">
                  10. <u>{t("terms.disclaimer")}</u>
                  <div className="terms-container margin-top-10">
                    <div className="marginBtm5">
                      <b>a.</b>
                      {t("terms.disclaimerTextA")}
                    </div>
                    <div className="marginBtm5">
                      <b>b.</b>
                      {t("terms.disclaimerTextB")}
                    </div>
                    <div className="marginBtm5">
                      <b>c.</b>
                      {t("terms.disclaimerTextC")}
                    </div>
                  </div>
                </div>
                <div className="marginBtm10">
                  11. <u>{t("terms.indemnity")}</u>
                  {t("terms.indemnityText")}
                </div>
                <div className="marginBtm10">
                  12. <u>{t("terms.governingLaw")}</u>
                  {t("terms.governingLawText")}
                </div>
                <div className="marginBtm10">
                  13. <u>{t("terms.severability")}</u>
                  {t("terms.severabilityText")}
                </div>
              </div>
            </div>
            <div className="terms-checkbox-row">
              <input
                type="checkbox"
                id="agree-terms"
                checked={agreeToTerms}
                onChange={() => setAgreeToTerms(!agreeToTerms)}
                className="terms-checkbox"
              />
              <label htmlFor="agree-terms">{t("requestAcess.agreeT&C")}</label>
            </div>

            <DupontButton onClick={handleConfirm} disabled={!agreeToTerms}>
              {t("requestAcess.requestAccess")}
            </DupontButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestAccess;
